<template>
  <div>
    <v-card class="mb-4" v-for="[group, invoices] of itemsGrouped" :key="group">
      <v-system-bar>
        {{ invoices[0].group.number }} – {{ invoices[0].group.description }}
      </v-system-bar>
      <v-toolbar flat dense>
        <v-btn color="danger" text @click="ungroup(invoices[0].group.id)">
          Gruppierung aufheben
        </v-btn>
        <v-spacer />
        <v-btn
          text
          color="success"
          :to="{
            name: 'InvoiceDepartmentGroup',
            params: { id: invoices[0].group.id, page: 'InvoiceDepartment' },
          }"
        >
          Verteilen
        </v-btn>
        <CurrencyValue
          :value="invoices.reduce((sum, invoice) => sum + invoice.amount, 0)"
        />
      </v-toolbar>
      <v-divider />
      <InvoiceTable
        showEmployee
        :items="invoices"
        page="InvoiceDepartment"
        disabled
      />
    </v-card>
    <v-card>
      <v-system-bar>Ungruppierte FS-Sammelrechnungen</v-system-bar>
      <v-toolbar flat dense>
        <v-spacer />
        <v-btn
          text
          color="success"
          :disabled="!selected.length || selected.length < 2"
          @click="groupInvoices()"
        >
          Gruppieren
        </v-btn>
      </v-toolbar>
      <v-divider />
      <DepartmentInvoiceTable
        v-model="selected"
        :items="itemsFilteredUngrouped"
        page="InvoiceDepartment"
      />
    </v-card>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import CurrencyValue from "common/components/CurrencyValue.vue";
import DepartmentInvoiceTable from "./Components/DepartmentInvoiceTable.vue";
import InvoiceTable from "./Components/InvoiceTable.vue";

export default defineComponent({
  components: {
    DepartmentInvoiceTable,
    InvoiceTable,
    CurrencyValue,
  },
  props: {
    search: { type: String },
  },
  data() {
    return {
      items: [],
      selected: [],
    };
  },
  computed: {
    itemsFiltered() {
      return this.items.filter(
        (item) =>
          item.event.toLowerCase().includes(this.search.toLowerCase()) ||
          item.description.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    itemsFilteredUngrouped() {
      return this.itemsFiltered.filter((item) => !item.group);
    },
    itemsGrouped() {
      return Map.groupBy(
        this.items.filter((item) => item.group),
        (item) => item.group.id
      );
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.selected = [];
      this.items = await this.apiList({
        resource: "finance/invoice",
        query: "status=department",
      });
      this.loading = false;
    },
    async groupInvoices() {
      this.loading = true;
      const description = await this.$root.prompt({
        message: "Geben Sie eine Beschreibung für die Gruppierung ein.",
        label: "Beschreibung",
      });
      if (!description) {
        this.loading = false;
        return;
      }
      await this.apiPost({
        resource: "finance/invoicegroup",
        data: { ids: this.selected, department: "BG", description },
      });
      this.fetchData();
      // this.showGroup(group.id);
    },
    async ungroup(groupId) {
      if (
        await this.$root.confirm({
          message:
            "Sollen die Rechnungen aus der Gruppe gelöst und einzeln weiterverarbeitet werden?",
          color: "danger",
        })
      ) {
        this.working = true;

        await this.apiDelete({
          resource: "finance/invoicegroup",
          id: groupId,
        });

        this.fetchData();
        this.working = false;
      }
    },
  },
  async created() {
    this.fetchData();
  },
});
</script>
